module.exports = __webpack_public_path__ + "static/media/Hair_1.a94017de.jpg";